import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import './App.css';
import LaceProduct from './components/LaceProduct';
import config from './config';

const fetchOptions = {};

async function fetchWithRetry(url, maxRetries = 3) {
    let lastErr;
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const response = await fetch(url, fetchOptions);
            if (response.ok) return response;
            throw new Error(`HTTP ${response.status}`);
        } catch (err) {
            lastErr = err;
            if (attempt < maxRetries) {
                await new Promise(r => setTimeout(r, Math.pow(2, attempt) * 500));
            }
        }
    }
    throw lastErr;
}

function App() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [allDesenIds, setAllDesenIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [gorusmeInfo, setGorusmeInfo] = useState(null);
    const [orderData, setOrderData] = useState({});
    const [huid, setHuid] = useState('');
    const [showShareDialog, setShowShareDialog] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');
    const [shareLink, setShareLink] = useState('');
    const [secimData, setSecimData] = useState(null);
    const ITEMS_PER_PAGE = 5;

    // URL'den ID'yi al 
    // 3D889530-7438-492A-BF5F-221C5BC6224C
    // 1335EB93-535D-4CA0-BB0D-8D79AF41A67D

    const [searchParams] = useSearchParams();
    const urlid = searchParams.get('id');
    const ogn = searchParams.get('ogn');
    const uid = searchParams.get('uid');
    const recycle = searchParams.has('recycle');
    const maxrecycle = searchParams.has('maxrecycle');

    //  console.log('URL Parameters:', { urlid, ogn, uid, recycle, maxrecycle });
    console.log('id:', urlid);
    /* console.log('URL Parameters:', { urlid, ogn, uid, recycle, maxrecycle });
     console.log('id:', urlid);
     console.log('uid:', uid);
     console.log('ogn:', ogn);*/
    // Sadece desen listesini al
    useEffect(() => {
        // URL parametreleri değiştiğinde state'leri sıfırla
        setProducts([]);
        setCurrentPage(0);
        setAllDesenIds([]);
        setSecimData(null);
        setGorusmeInfo(null);
        setOrderData({});
        setHuid('');
        setLoading(true);
        setError(null);
        loadingRef.current = false; // Yükleme bayrağını sıfırla

        async function fetchDesenList() {
            console.log("fetchDesenList içinde uid:", uid);
            try {
                // URL'de uid varsa sipariş listesinden, ogn varsa ogn endpoint'inden, yoksa normal endpoint'den al
                let endpoint;


                if (uid) {
                    // console.log("uid xxxxxx", uid);
                    endpoint = `${config.API_BASE_URL}/siparislistesi?id=${urlid}&uid=${uid}`;
                    console.log("userlistesi", endpoint);
                } else if (ogn) {
                    endpoint = `${config.API_BASE_URL}/desensecimleriogn?id=${urlid}&ogn=${ogn}`;
                } else {
                    endpoint = `${config.API_BASE_URL}/desensecimleri?id=${urlid}`;
                }

                const response = await fetchWithRetry(endpoint);
                if (!response.ok) {
                    throw new Error('Desen listesi alınamadı');
                }
                const data = await response.json();
                const desenIds = Array.from(new Set(
                    data[0].DESENLER.split(',')
                        .map(id => id.trim())
                        .filter(Boolean)
                )).sort((a, b) => b.localeCompare(a, undefined, { numeric: true }));
                //  console.log('Alınan tüm desen IDleri (uniq):', desenIds);
                setAllDesenIds(desenIds);

                // uid varsa SECIMDATA'yı parse et ve sakla
                if (uid && data[0].SECIMDATA) {
                    try {
                        const parsedSecimData = JSON.parse(data[0].SECIMDATA);
                        setSecimData(parsedSecimData);
                        console.log('Seçim Data:', parsedSecimData);
                    } catch (parseError) {
                        console.error('SECIMDATA parse hatası:', parseError);
                    }
                }

                // ogn varsa görüşme bilgilerini sakla
                if (ogn) {
                    setGorusmeInfo(data[0]);
                }

                setLoading(false);
            } catch (err) {
                console.error('Desen listesi alınırken hata:', err);
                setError('Desen listesi alınamadı');
                setLoading(false);
            }
        }

        if (urlid) {
            fetchDesenList();
        } else {
            // urlid yoksa loading'i kapat
            setLoading(false);
        }
    }, [urlid, ogn, uid]);

    // Ürünleri yükle
    const loadingRef = useRef(false);

    const handleLoadMore = useCallback(async () => {
        if (loadingRef.current) {
            return;
        }
        // Yarış durumunu engellemek için bayrağı erken set et
        loadingRef.current = true;
        if (currentPage * ITEMS_PER_PAGE >= allDesenIds.length) {
            loadingRef.current = false;
            return;
        }

        try {
            setLoading(true);
            const start = currentPage * ITEMS_PER_PAGE;
            const end = start + ITEMS_PER_PAGE;
            const pageIds = allDesenIds.slice(start, end);
            //  console.log('Yüklenecek sayfa:', currentPage);
            //  console.log('Yüklenecek ID aralığı:', start, '-', end);
            //  console.log('Yüklenecek desen IDleri:', pageIds);

            const newProducts = [];
            for (const id of pageIds) {
                try {
                    const response = await fetchWithRetry(`${config.API_BASE_URL}/desenbilgi?desen=${id}`);
                    const data = await response.json();
                    if (!Array.isArray(data) || data.length === 0) {
                        throw new Error(`Desen ${id} için veri bulunamadı`);
                    }

                    const product = data[0];

                    // API'den dönen ürün beklenen desenle eşleşmiyorsa atla
                    if (product.DENEME_NO !== id) {
                        console.warn(`Beklenen desen ${id}, ancak API ${product.DENEME_NO} döndürdü. Kayıt listeye eklenmedi.`);
                        continue;
                    }

                    // Aynı ürünün alt istekleri birbirinden bağımsız, paralel gönder
                    const subRequests = [
                        fetchWithRetry(`${config.API_BASE_URL}/renkler?desen=${id}&urlid=${urlid}`).then(r => r.json()).catch(() => []),
                        fetchWithRetry(`${config.API_BASE_URL}/leftovers?desen=${id}&urlid=${urlid}`).then(r => r.json()).catch(() => []),
                        fetchWithRetry(`${config.API_BASE_URL}/katalogresimleri?desen=${id}&urlid=${urlid}`).then(r => r.json()).catch(() => []),
                        fetchWithRetry(`${config.API_BASE_URL}/hareketliresim?desen=${id}&urlid=${urlid}`).then(r => r.json()).catch(() => []),
                        ogn ? fetchWithRetry(`${config.API_BASE_URL}/desensecimleriognfiyat?ogn=${ogn}&desen=${id}`).then(r => r.json()).catch(() => []) : Promise.resolve([]),
                    ];
                    const [renkler, leftovers, katalog, hareketli, fiyat] = await Promise.all(subRequests);
                    product.RENK_BILGILERI = renkler;
                    product.LEFTOVERS_BILGILERI = leftovers;
                    product.KATALOG_RESIMLERI = katalog;
                    product.HAREKETLI_RESIMLER = hareketli;
                    if (ogn) product.FIYAT_BILGILERI = fiyat;

                    newProducts.push(product);
                } catch (error) {
                    console.error(`Desen ${id} yüklenirken hata:`, error);
                }
            }

            //  console.log('Mevcut ürünler:', products);
            //  console.log('Yeni yüklenen ürünler:', newProducts);

            setProducts(prevProducts => {
                const merged = [...prevProducts, ...newProducts];
                const seen = new Set();
                return merged.filter(p => {
                    const key = p.DENEME_NO;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                });
            });
            setCurrentPage(prev => prev + 1);
        } catch (err) {
            console.error('Genel hata:', err);
            setError('Ürünler yüklenirken hata oluştu');
        } finally {
            setLoading(false);
            loadingRef.current = false;
        }
    }, [currentPage, allDesenIds, ogn]);

    const hasMore = currentPage * ITEMS_PER_PAGE < allDesenIds.length;

    // Sıralı otomatik yükleme - Her sayfa yüklendikten sonra bir sonrakini yükle
    useEffect(() => {
        // Desen listesi hazır ve henüz yükleme devam ediyorsa
        if (allDesenIds.length > 0 && hasMore && !loadingRef.current) {
            handleLoadMore();
        }
    }, [allDesenIds, currentPage, hasMore, handleLoadMore]);

    // Form verilerini güncelle
    const updateOrderData = useCallback((desenNo, data) => {
        setOrderData(prev => ({
            ...prev,
            [desenNo]: data
        }));
    }, []);

    // Share butonuna tıklandığında
    const handleShareFavoriteList = async () => {
        const dataArray = Object.entries(orderData)
            .filter(([_, data]) => data.renk && data.renk.length > 0) // Sadece renk seçilmiş olanlar
            .map(([desen, data]) => ({
                desen,
                renk: data.renk.map(c => c.value || c),
                tip: data.tip || '',
                miktar: data.miktar || '',
                birim: data.birim || ''
            }));

        if (dataArray.length === 0) {
            setWarningMessage('Please select at least one item and color to create a share link.');
            return;
        }

        // Desen numaralarını virgülle birleştir
        const desenler = dataArray.map(item => item.desen).join(',');

        const result = {
            id: urlid,
            huid: huid,
            desenler: desenler,
            data: JSON.stringify(dataArray)
        };

        try {
            // İstek gönder
            const response = await fetch(`${config.API_BASE_URL}/sipariskayit?id=${result.id}&data=${encodeURIComponent(result.data)}&huid=${result.huid}&desenler=${result.desenler}`, {
                cache: 'no-store',
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache'
                }
            });
            const apiResult = await response.json();
            console.log('API Sonucu:', apiResult);

            // API'den gelen LINKID_USER'ı huid state'ine ata
            if (apiResult && apiResult[0] && apiResult[0].LINKID_USER) {
                setHuid(apiResult[0].LINKID_USER);

                // Share link oluştur ve dialog'u aç
                const link = `${config.WEB_BASE_URL}/?id=${urlid}&uid=${apiResult[0].LINKID_USER}`;
                setShareLink(link);
                setShowShareDialog(true);
            }
        } catch (error) {
            console.error('API Hatası:', error);
        }
    };

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <div className="app">
            <header>
                <img className="logo" width={550} src={config.WEB_BASE_URL + "/Logo.svg"} alt="Antik Dantel Logo" />
            </header>

            {gorusmeInfo && (
                <div className="gorusme-info-card">
                    <div className="info-row">
                        <span className="info-label">Form Ref.</span>
                        <span className="info-value">: {gorusmeInfo.GORUSME_NO}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Date</span>
                        <span className="info-value">: {gorusmeInfo.TARIH}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Customer</span>
                        <span className="info-value">: {gorusmeInfo.MUSTERI_ADI}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">Representative</span>
                        <span className="info-value">: {gorusmeInfo.MUSTERI_TEMSILCISI}</span>
                    </div>
                </div>
            )}

            <div className="products-grid">
                {products.map((product, index) => {
                    const secim = secimData?.find(s => s.desen === product.DENEME_NO);
                    return (
                        <LaceProduct
                            key={`${product.DENEME_NO}-${index}`}
                            product={product}
                            onOrderDataChange={updateOrderData}
                            isReadOnly={!!uid}
                            secimData={secim}
                            showRecycle={recycle}
                            showMaxRecycle={maxrecycle}
                        />
                    );
                })}
            </div>

            {loading && hasMore && (
                <div className="loading-indicator">
                    <div className="spinner"></div>
                </div>
            )}

            {!uid && (
                <div className="share-favorite-container">
                    <button className="share-favorite-btn" onClick={handleShareFavoriteList}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                            <polyline points="16 6 12 2 8 6" />
                            <line x1="12" y1="2" x2="12" y2="15" />
                        </svg>
                        Share Favorite List
                    </button>
                </div>
            )}

            <footer className="footer">
                <img src={config.WEB_BASE_URL + "/footer.svg"} alt="footer" className="footer-image" />
            </footer>

            {/* Warning Dialog */}
            {warningMessage && (
                <div className="share-dialog-overlay" onClick={() => setWarningMessage('')}>
                    <div className="share-dialog warning-dialog" onClick={(e) => e.stopPropagation()}>
                        <div className="share-dialog-header">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="12" />
                                <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            <span>Notice</span>
                            <button className="close-btn" onClick={() => setWarningMessage('')}>×</button>
                        </div>
                        <div className="warning-dialog-content">
                            <p className="warning-dialog-text">{warningMessage}</p>
                            <button className="warning-dialog-btn" onClick={() => setWarningMessage('')}>
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Share Dialog */}
            {showShareDialog && (
                <div className="share-dialog-overlay" onClick={() => setShowShareDialog(false)}>
                    <div className="share-dialog" onClick={(e) => e.stopPropagation()}>
                        <div className="share-dialog-header">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                                <polyline points="16 6 12 2 8 6" />
                                <line x1="12" y1="2" x2="12" y2="15" />
                            </svg>
                            <span>Share Favorite List</span>
                            <button className="close-btn" onClick={() => setShowShareDialog(false)}>×</button>
                        </div>
                        <div className="share-dialog-content">
                            <input
                                type="text"
                                value={shareLink}
                                readOnly
                                className="share-link-input"
                            />
                            <button
                                className="copy-btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(shareLink);
                                    setWarningMessage('Link copied to clipboard!');
                                }}
                                title="Copy"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                </svg>
                            </button>
                            <button
                                className="open-btn"
                                onClick={() => window.open(shareLink, '_blank')}
                                title="Yeni sekmede aç"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                    <polyline points="15 3 21 3 21 9"></polyline>
                                    <line x1="10" y1="14" x2="21" y2="3"></line>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default App;